import Button from '@/components/buttons/Button/Button'
import LazyLoader from '@/components/common/LazyLoader/LazyLoader'
import { ArticleModel } from '@/types/api'
import ISearchResultSettings from '@/types/ISearchResultSettings'
import useAddToCart from '@/utils/hooks/useAddToCart'
import usePrice from '@/utils/hooks/usePrice'
import Image from 'next/image'
import React from 'react'
import styles from './ListView.module.scss'
import { useTranslation } from 'next-i18next'

type Props = {
  items: ArticleModel[],
  settings: ISearchResultSettings,
  onSelect?: (item: ArticleModel) => void
}

const ListView = ({
  items,
  settings,
  onSelect
}: Props) => {
  const { addToCart } = useAddToCart()
  const { price } = usePrice()
  const { t } = useTranslation('shop')

  const onBuyClick = (item: ArticleModel) => {
    addToCart({
      articleId: item.id,
      quantity: 4,
      articleText: item.articleText,
      price: item.price,
    })
  }

  const onClickSelect = (item: ArticleModel) => {
    if (onSelect)
      onSelect(item)
  }

  const getListComponent = (item: ArticleModel) => {
    return (
      <div className={styles.item} key={item.id}>
        <div className={styles.imageColumn}>
          {item.imageId && (
            <Image
              src={`${process.env.NEXT_PUBLIC_API}/images/${item.imageId}`}
              alt={item.brandName}
              width={70}
              height={70}
            />
          )}
        </div>
        {settings.showBrand && (
          <div className={styles.brand}>{item.brandName}</div>
        )}
        {/* {settings.showModel && (
          <div className={styles.model}>{item.modelName}</div>
        )} */}
        <div className={styles.articleText}>{item.articleText}</div>
        <div className={styles.price}>{price(item.price, true)}</div>
        <div className={styles.buy}>
          {settings.showSelectButton ? (
            <Button
              onClick={() => onClickSelect(item)}
              label={t('common:select')}
            />
          ) : (
            <Button
              onClick={() => onBuyClick(item)}
              label={t('common:search.buy')}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.component}>
      {items && items.length > 0 && (
        <div className={styles.header}>
          <div className={styles.image}></div>
          {settings.showBrand && (
            <div className={styles.brand}>{t('shop:brand')}</div>
          )}
          {settings.showModel && (
            <div className={styles.model}>{t('shop:model')}</div>
          )}
          <div className={styles.articleText}>{t('common:articleText')}</div>
          <div className={styles.price}>{t('common:price')}</div>
          <div className={styles.buy}></div>
        </div>
      )}
      <LazyLoader
        items={items}
        itemsPerLoad={20}
        getComponent={getListComponent}
      />
    </div>
  )
}

export default ListView